import {MasterOfActsAPI} from "../../api/api";

const SET_ACTIVE_ENVIRONMENT_STATE = 'masterOfActs/SET_ACTIVE_ENVIRONMENT_STATE'
const SET_NORMATIVE_ARTICLES = 'masterOfActs/SET_NORMATIVE_ARTICLES'
const ADD_NORMATIVE_ARTICLES = 'masterOfActs/ADD_NORMATIVE_ARTICLES'
const SET_TABLE_TEMPLATE = 'masterOfActs/SET_TABLE_TEMPLATE'
const SET_REFERENCE_DESCRIPTION = 'masterOfActs/SET_REFERENCE_DESCRIPTION'
const SET_NORMATIVE_DOCUMENTS = 'masterOfActs/SET_NORMATIVE_DOCUMENTS'


const initialState = {
    activeEnvironmentState: null,
    normativeArticles: {results: []},
    normativeDocuments: null,
    referenceDescription: null,
    tableTemplate: null
}

export const masterOfActs = (state = initialState, action) => {
    switch (action.type) {
        case SET_ACTIVE_ENVIRONMENT_STATE:
            return {...state, activeEnvironmentState: action.activeEnvironmentState}
        case SET_NORMATIVE_ARTICLES:
            return {...state, normativeArticles: action.normativeArticles}
        case ADD_NORMATIVE_ARTICLES:
            return {
                ...state, normativeArticles: {
                    ...state.normativeArticles,
                    ...action.normativeArticles,
                    results: [
                        ...state.normativeArticles.results, ...action.normativeArticles.results
                    ]
                }
            }
        case SET_TABLE_TEMPLATE:
            return {...state, tableTemplate: action.tableTemplate}
        case SET_REFERENCE_DESCRIPTION:
            return {...state, referenceDescription: action.referenceDescription}
        case SET_NORMATIVE_DOCUMENTS:
            return {...state, normativeDocuments: action.normativeDocuments}
        default:
            return state
    }
}


export const getActiveEnvironmentState = (state) => state.masterOfActs.activeEnvironmentState
export const getNormativeArticles = (state) => state.masterOfActs.normativeArticles
export const getTableTemplate = (state) => state.masterOfActs.tableTemplate
export const getReferenceDescription = (state) => state.masterOfActs.referenceDescription
export const getNormativeDocuments = (state) => state.masterOfActs.normativeDocuments


export const setActiveEnvironmentState = (activeEnvironmentState) => ({
    type: SET_ACTIVE_ENVIRONMENT_STATE,
    activeEnvironmentState
})
export const setNormativeArticles = normativeArticles => ({type: SET_NORMATIVE_ARTICLES, normativeArticles})
export const addNormativeArticles = normativeArticles => ({type: ADD_NORMATIVE_ARTICLES, normativeArticles})
export const setTableTemplate = tableTemplate => ({type: SET_TABLE_TEMPLATE, tableTemplate})
export const setReferenceDescription = referenceDescription => ({type: SET_REFERENCE_DESCRIPTION, referenceDescription})
export const setNormativeDocuments = normativeDocuments => ({type: SET_NORMATIVE_DOCUMENTS, normativeDocuments})


export const loadingActiveEnvironmentState = project => async dispatch => {
    const response = await MasterOfActsAPI.getEnvironmentStates(null, project, null, null, true)
    if (response.status === 200) {
        dispatch(setActiveEnvironmentState(response.data[0]))
    }
}

export const loadEnvironmentState = environmentStateId => async dispatch => {
    const environmentState = await MasterOfActsAPI.getEnvironmentState(environmentStateId)

    if (environmentState.status === 200) {
        dispatch(setActiveEnvironmentState(environmentState.data))
    }
}

export const loadNormativeArticles = (normativeDocuments, searchString) => async dispatch => {
    const response = await MasterOfActsAPI.getNormativeArticles(normativeDocuments, searchString)

    if (response.status === 200) {
        dispatch(setNormativeArticles(response.data))
    }
}

export const loadNextNormativeArticlesChunk = (normativeDocuments, searchString, url) => async dispatch => {
    const response = await MasterOfActsAPI.getNormativeArticles(normativeDocuments, searchString, url)

    if (response.status === 200) {
        dispatch(addNormativeArticles(response.data))
    }
}

export const loadTableTemplate = project => async dispatch => {
    const response = await MasterOfActsAPI.getTableTemplate(project)

    if (response.status === 200) {
        dispatch(setTableTemplate(response.data[0]))
    }
}

export const changeTableTemplate = tableTemplate => async dispatch => {
    const response = await MasterOfActsAPI.changeTableTemplate(tableTemplate.id, tableTemplate)

    if (response.status === 200) {
        dispatch(setTableTemplate(response.data))
    }
}

export const loadReferenceDescription = handbook => async dispatch => {
    const response = await MasterOfActsAPI.getReferenceDescription(handbook)

    if (response.status === 200) {
        const referenceDescriptions = []
        for (const referenceDescription of response.data) {
            const normativeDocument = await MasterOfActsAPI.getNormativeDocument(referenceDescription.normative_document)
            if (normativeDocument.status === 200) {
                referenceDescriptions.push({...referenceDescription, normative_document: normativeDocument.data})
            }
        }
        dispatch(setReferenceDescription(referenceDescriptions))
    }
}

export const loadNormativeDocumentsById = ids => async dispatch => {
    const responses = await Promise.all(ids.map(id => MasterOfActsAPI.getNormativeDocument(id)))

    const normativeDocument = []

    for (const response of responses) {
        if (response.status === 200) {
            normativeDocument.push(response.data)
        }
    }
    dispatch(setNormativeDocuments(normativeDocument))
}